import { useEffect, useState, useCallback } from 'react';
import LayoutPage from "../../templates/Layout/LayoutPage";
import MaterialTable, { MTableToolbar } from '@material-table/core';
import axios from 'axios';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Divider from '@mui/material/Divider';
import Button from "@mui/material/Button";
import ReportButtons from "../../components/organisms/BugReport/ReportButtons";
import { useAuth0 } from "@auth0/auth0-react";
import { TabsStyles } from "./Cruds.styles";
import Box from "@mui/material/Box";
import { nameValidation, getToken } from 'src/utils/helpsers';

const CrudCustomBoards = () => {
  const [groups, setGroups] = useState([]);
  const [userGroups, setUserGroups] = useState([]);
  const [iserror, setIserror] = useState(false);
  const [errorMessages, setErrorMessages] = useState([]);
  const [activeUser, setActiveUser] = useState([]);
  const [activeTab, setActiveTab] = useState('my_group');

  const { user } = useAuth0();
  const enabledShare = user[`${process.env.REACT_APP_AUTH0_KEY}/district`].enable_share;

  let tabs = [
    { 'name': 'My Groups', 'value': 'my_group' },
    { 'name': 'Shared with me', 'value': 'shared_with' }
  ];

  if(!enabledShare) {
    tabs = tabs.filter(el => el.value !== "shared_with");
  }


  const [users, setUsers] = useState([]);
  const [columns, setColumns] = useState([]);

  const defineColumns = useCallback((tab) => {
    if (tab === 'shared_with') {
      return [
        {
          title: 'Name', field: 'label', editable: 'never',
          render: props => {
            return (
              <a
                href={'/custom-groups?shared=' + props.uuid}
                target="_blank"
                rel="noopener noreferrer"
                className="btn form-submit"
              >
                {props.label}
              </a>
            );
          },
        },
        { title: 'Description', field: 'description', editable: 'never' },
        { title: 'Owner', field: 'created_by', editable: 'never' }
      ]
    }
    if (tab === 'my_group') {
      let columns = [
        {
          title: 'Name', field: 'label',
          validate: rowData => {
            if (!rowData.label) {
              return 'Name cannot be blank';
            } else if((/^(\s)/g).test(rowData.label) || (/(\s)$/g).test(rowData.label)){
              return 'The name can not start or end with a white space'
            } else if((/[^\s]*\s{2,}/g).test(rowData.label)){
              return 'Do not group multiple white spaces'
            } else if (rowData.label.length < 3) {
              return 'Name must have at least three letters';
            }
            return true;
          },
          render: props => {
            return (
              <a
                href={'/custom-groups?shared=' + props.uuid}
                target="_blank"
                rel="noopener noreferrer"
                className="btn form-submit"
              >
                {props.label}
              </a>
            );
          },
        },
        { title: 'Description', field: 'description' },
        {
          title: 'Shared with', field: 'available_users_share',
          render: props => {
            let available_users = [];

            if (props.available_users_share) {
              props.available_users_share.forEach(availableUser => {
                available_users.push(availableUser.label);
              })
            }

            const listUsers = available_users.map((available_user) =>
              <>
                <p>{available_user}</p>
                <Divider variant="fullWidth" />
              </>
            );

            return (
              listUsers
            );
          },
          editComponent: props => {
            let filteredUsers = users.filter((userF) => userF.group_id === activeUser.group_id ? userF : false);
            let usersFormat = filteredUsers.map((userF) => {
              let userGroup = userGroups.find(userGroup => userGroup.id === userF.group_id);
              return ({ 'value': userF.email, 'label': userF.name + ' @ ' + userGroup.name });
            });

            return (
              <Autocomplete
                multiple
                options={usersFormat}
                id={'shared-with'}
                label="Shared with"
                defaultValue={props.value}
                onChange={(e, newValue) => {
                  props.onChange(newValue);
                }} 
                renderInput={(params) => (
                  <TextField {...params}/>
                )}
              />
            );
          }
        }
      ]
      return enabledShare ? columns : columns.filter( el => el.field !== "available_users_share");
    }
  }, [activeUser.group_id, userGroups, users, enabledShare]);

  const getGroups = useCallback(() => {
    if (activeTab === 'shared_with') {
      axios.get(`${process.env.REACT_APP_API_URL}/rpc/hvd_shared_group?_email=${encodeURIComponent(user.email)}`, {
        headers: {
          'ngrok-skip-browser-warning': true
        }
      })
        .then(res => {
          setGroups(res.data);
        });
    } else {
      axios.get(`${process.env.REACT_APP_API_URL}/custom_groups?created_by=eq.${encodeURIComponent(user.email)}`, {
        headers: {
         'ngrok-skip-browser-warning': true   
        }
      })
        .then(res => {
          setGroups(res.data);
        });
    }
    axios.get(`${process.env.REACT_APP_API_URL}/groups`, {
      headers: {
        'ngrok-skip-browser-warning': true
      }
    })
      .then(res => {
        return setUserGroups(res.data);
      });
  }, [activeTab, user.email]);

  useEffect(() => {
    getGroups();
    axios.get(`${process.env.REACT_APP_API_URL}/users`, {
      headers: {
       'ngrok-skip-browser-warning': true   
      }
    })
      .then(res => {
        setUsers(res.data);

        let currentUser = res.data.find((element, index) => {
          let valid = false;

          if (element.email === user.email) {
            valid = true;
          }

          return valid;
        });

        setActiveUser(currentUser);
      });
  }, [getGroups, user]);

  useEffect(() => {
    setColumns(defineColumns(activeTab));
  }, [activeTab, defineColumns]);

  //function for updating the existing row details
  const handleRowUpdate = (newData, oldData, resolve) => {
    // Cloning object and deleting the keys not required on data update.
    let dataToUpdate = structuredClone(newData);
    delete dataToUpdate.tableData;

    // Apply the .trim() method to the "label" value before updating the row data
    dataToUpdate.label = dataToUpdate.label.trim();

    if (!nameValidation({ arr: groups, name: dataToUpdate.label, key: 'label' })) {
      setErrorMessages(["Group name is already in use"]);
      setIserror(true);
      resolve();
      return;
    }

    //validating the data inputs
    let errorList = [];

    if (errorList.length < 1) {
      axios.put(`${process.env.REACT_APP_API_URL}/custom_groups?uuid=eq.${newData.uuid}`, dataToUpdate,{
        headers: {
          'ngrok-skip-browser-warning': true,
          'Authorization': `Bearer ${getToken()}`,
        }
      })
        .then(response => {
          getGroups();
          resolve();
          setIserror(false);
          setErrorMessages([]);
        })
        .catch(error => {
          if (error.response) {
            // Request made and server responded
            setErrorMessages([`Update Failed! ${error.response.data.details}`]);
          }

          setIserror(true);
          resolve();
        })
    } else {
      setErrorMessages(errorList);
      setIserror(true);
      resolve();
    }
  }

  return (
    <LayoutPage
      type = 'crud'
      pageTitle='Custom Groups'
      description='View, and update custom groups.'
      customClass='page-crud'
    >
      <>
        <Box className="GroupsButtons" sx={TabsStyles}>
          {
            tabs.map((tab, key) =>
              <Button
                key={key}
                className={`GroupsButtons__item ${key === 0 ? 'active' : ''}`}
                onClick={(e) => {
                  let buttons = document.querySelectorAll('.GroupsButtons__item');
                  buttons.forEach(button => button.classList.remove('active'));
                  e.currentTarget.className += " active";
                  setActiveTab(tab.value);
                }}
              >
                {tab.name}
              </Button>
            )
          }
        </Box>
        <MaterialTable
          title="Custom Groups"
          columns={columns}
          data={groups}
          options={{
            headerStyle: { borderBottomColor: '#773dbd', borderBottomWidth: '3px' },
            actionsColumnIndex: -1,
            toolbarButtonAlignment: "left",
            pageSize: 20,
            emptyRowsWhenPaging: false,
            pageSizeOptions: [10, 20, 30, 50]
          }}
          components={{
            Toolbar: props => (
              <MTableToolbar {...props} classes={{ root: "board-toolbar" }} />
            ),
          }}
          editable={
            activeTab !== 'shared_with' ? {
              onRowUpdate: (newData, oldData) =>
                new Promise((resolve) => {
                  handleRowUpdate(newData, oldData, resolve);
                })
            } : {}}
        />

        <div>
          <Snackbar open={iserror} autoHideDuration={5000} onClose={() => setIserror(false)}>
              <Alert
                sx={{ position: 'fixed', bottom: '10px', left: "5px", zIndex: "1" }}
                severity="error"
                variant="filled"
                onClose={() => setIserror(false)}
                >
                {errorMessages.map((msg, i) => {
                  return <div key={i}>{msg}</div>
                })}
              </Alert>
            </Snackbar>  
        </div>
        <ReportButtons boardType={'Groups'} />
      </>
    </LayoutPage>
  );
}

export default CrudCustomBoards;
